import { c as _c } from "react/compiler-runtime";
import { Card } from '@onefootprint/ui';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Subsection as SubsectionBody } from '@/components/entity-onboarding-details';
import type { WithEntityProps } from '@/entity/components/with-entity';
import useCurrentEntityDuplicateData from '@/entity/hooks/use-current-entity-duplicate-data';
import useCurrentEntityOtherInsights from '@/entity/hooks/use-current-entity-other-insights';
import DeviceInsights from '../../../device-insights';
import DuplicateData from '../../../duplicate-data';
import OtherInsights from '../../../other-insights';
import { getSubsectionAnchorId } from '../../constants';
type CurrentCard = {
  key: string;
  title: string;
  isEmpty?: boolean;
  isBare?: boolean;
  content: ReactNode;
};

/** The live state of what the onboarding cards rewind: every device event, today's dupes, consolidated insights. */
const CurrentData = t0 => {
  const $ = _c(5);
  const {
    entity
  } = t0;
  const {
    t
  } = useTranslation("entity-details");
  const isPerson = entity.kind === "person";
  const {
    data: dupes
  } = useCurrentEntityDuplicateData(undefined, isPerson);
  const {
    data: insights
  } = useCurrentEntityOtherInsights();
  let t1;
  if ($[0] !== dupes?.data || $[1] !== insights || $[2] !== isPerson || $[3] !== t) {
    const cards = [...(isPerson ? [{
      key: "duplicate-data",
      title: t(_temp),
      isEmpty: dupes?.data.length === 0,
      content: <DuplicateData />
    }] : []), {
      key: "device-insights",
      title: t(_temp2),
      isBare: true,
      content: <DeviceInsights />
    }, {
      key: "other-insights",
      title: t(_temp3),
      isEmpty: Boolean(insights) && !insights?.some(_temp4),
      content: <SubsectionBody><OtherInsights /></SubsectionBody>
    }];
    t1 = <div className="flex flex-col gap-4">{cards.map(t2 => {
        const {
          key,
          title,
          isEmpty,
          isBare,
          content
        } = t2;
        return <Card.Root key={key} id={getSubsectionAnchorId(key)}><Card.Header title={title} rightContent={isEmpty ? t(_temp5) : undefined} />{!isEmpty && (isBare ? content : <Card.Body className="overflow-hidden">{content}</Card.Body>)}</Card.Root>;
      })}</div>;
    $[0] = dupes?.data;
    $[1] = insights;
    $[2] = isPerson;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default CurrentData;
function _temp($) {
  return $.duplicateData.title;
}
function _temp2($_0) {
  return $_0.deviceInsights.title;
}
function _temp3($_1) {
  return $_1.otherInsights.title;
}
function _temp4(insight) {
  return !insight.onboardingId;
}
function _temp5($_2) {
  return $_2.onboardings.none;
}